import { render, staticRenderFns } from "./AssignmentCompletionSection.vue?vue&type=template&id=609c8120&scoped=true&"
import script from "./AssignmentCompletionSection.vue?vue&type=script&lang=js&"
export * from "./AssignmentCompletionSection.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentCompletionSection.vue?vue&type=style&index=0&id=609c8120&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609c8120",
  null
  
)

export default component.exports